import { Translation } from "react-i18next"
import { createBrowserRouter } from "react-router-dom"

import SurveyAnswerShow from "@/features/pages/Surveys/SurveyAnswerShow"
import Surveys from "@/pages/Surveys/Surveys"

import FreeMaterialCourseDetails from "@/features/pages/FreeMaterials/FreeMaterialDetails/FreeMaterialCourseDetails"
import FreeMaterialDetailsPreview from "@/features/pages/FreeMaterials/FreeMaterialDetails/FreeMaterialDetailsPreview"
import FreeMaterialDetailsSubject from "@/features/pages/FreeMaterials/FreeMaterialDetails/FreeMaterialDetailsSubject"
import FreeMaterials from "@/pages/FreeMaterials/FreeMaterials"
import FreeMaterialsDetails from "@/pages/FreeMaterials/FreeMaterialsDetails"
import Page from "../components/Page/Page"
import IsLoggedIn from "../components/ProtectedRoutes/IsLoggedIn"
import IsNotLoggedIn from "../components/ProtectedRoutes/IsNotLoggedIn"
import EnrolledCoursesShow from "../features/pages/EnrolledCourses/EnrolledCoursesShow"
import CoursePlan from "../features/pages/EnrolledCourses/CoursePlan"
import LecturesDetailsShow from "../features/pages/EnrolledCourses/LecturesDetails/LecturesDetailsShow"
import VideosShow from "../features/pages/EnrolledCourses/VideosRoute/VideosShow"
import TicketsChatShow from "../features/pages/Tickets/TicketsChatShow"
import AuthLayout from "../layouts/AuthLayout/AuthLayout"
import MainLayout from "../layouts/MainLayout"
import EnrolledCourses from "../pages/EnrolledCourses/EnrolledCourses"
import ErrorPage from "../pages/ErrorPage/ErrorPage"
import Feedbacks from "../pages/Feedbacks/Feedbacks"
import Home from "../pages/Home/Home"
import Login from "../pages/Login/Login"
import Profile from "../pages/Profile/Profile"
import Projects from "../pages/Projects/Projects"
import Tickets from "../pages/Tickets/Tickets"
import TopOneShare from "@/pages/Share/TopOneShare"

const router = createBrowserRouter([
  {
    path: "/share/top-one/:id",
    element: <TopOneShare />,
  },
  {
    path: "/",
    element: (
      <IsNotLoggedIn>
        <MainLayout />
      </IsNotLoggedIn>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: (
          <Translation>
            {(t) => (
              <Page title={t("pageTitles.home")}>
                <Home />
              </Page>
            )}
          </Translation>
        ),
      },
      {
        path: "profile",
        element: (
          <Translation>
            {(t) => (
              <Page title={t("pageTitles.profile")}>
                <Profile />
              </Page>
            )}
          </Translation>
        ),
      },
      {
        path: "feedbacks",
        element: (
          <Translation>
            {(t) => (
              <Page title={t("pageTitles.feedbacks")}>
                <Feedbacks />
              </Page>
            )}
          </Translation>
        ),
      },
      {
        path: "projects/:page?",
        element: (
          <Translation>
            {(t) => (
              <Page title={t("pageTitles.projects")}>
                <Projects />
              </Page>
            )}
          </Translation>
        ),
      },
      {
        path: "surveys",
        children: [
          {
            path: ":page?",
            element: (
              <Translation>
                {(t) => (
                  <Page title={t("pageTitles.surveys")}>
                    <Surveys />
                  </Page>
                )}
              </Translation>
            ),
          },
          {
            path: ":page?/answer/:id",
            element: (
              <Translation>
                {(t) => (
                  <Page title={t("pageTitles.answers")}>
                    <SurveyAnswerShow />
                  </Page>
                )}
              </Translation>
            ),
          },
        ],
      },
      {
        path: "free-materials",
        element: (
          <Translation>
            {(t) => (
              <Page title={t("pageTitles.freeMaterials")}>
                <FreeMaterials />
              </Page>
            )}
          </Translation>
        ),
      },
      {
        path: "free-materials/:courseId/details",
        element: (
          <Translation>
            {(t) => (
              <Page title={t("pageTitles.freeMaterials")}>
                <FreeMaterialsDetails />
              </Page>
            )}
          </Translation>
        ),
        children: [
          {
            index: true,
            element: <FreeMaterialCourseDetails />,
          },
          {
            path: ":subjectId",
            element: <FreeMaterialDetailsSubject />,
          },
          {
            path: ":subjectId/:materialId",
            element: <FreeMaterialDetailsPreview />,
          },
        ],
      },
      {
        path: "tickets",
        children: [
          {
            path: ":page?",
            element: (
              <Translation>
                {(t) => (
                  <Page title={t("pageTitles.tickets")}>
                    <Tickets />
                  </Page>
                )}
              </Translation>
            ),
          },
          {
            path: ":page?/chat/:chatId",
            element: (
              <Translation>
                {(t) => (
                  <Page title={t("pageTitles.tickets")}>
                    <TicketsChatShow />
                  </Page>
                )}
              </Translation>
            ),
          },
        ],
      },
      {
        path: "enrolled",
        children: [
          {
            path: ":page?",
            element: (
              <Translation>
                {(t) => (
                  <Page title={t("pageTitles.enrolledCourses")}>
                    <EnrolledCourses />
                  </Page>
                )}
              </Translation>
            ),
            children: [
              {
                index: true,
                element: <EnrolledCoursesShow />,
              },

              {
                path: "round/:roundId",
                element: <LecturesDetailsShow />,
              },
              {
                path: "round/:roundId/plan",
                element: <CoursePlan />,
              },
              {
                path: "round/:roundId/lectures/:lectureId/videos",
                element: <VideosShow />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/",
    element: (
      <IsLoggedIn>
        <AuthLayout></AuthLayout>
      </IsLoggedIn>
    ),
    children: [
      {
        path: "login",
        element: <Login />,
      },
    ],
  },
])

export default router
